var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarCupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.6 10.4",
    style: {
      enableBackground: "new 0 0 11.6 10.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.7,3.8C0.5,3.2,0.6,1,0.6,1l0-0.3h2.2v0.6H1.2c0.1,0.5,0.3,1.6,1.7,2L2.7,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,3.9L8.5,3.3c1.5-0.3,1.8-1.5,1.9-2H8.6V0.7H11L11,1C11,1,11.1,3.4,8.6,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,8.4H3.4v0.6c0,0-1-0.1-1.1,0.8v0.6h6.9V9.8c0,0,0-0.7-1.1-0.7V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,0v3.9c0,0-0.2,2.1,2.3,2.9v0.9h1.6V6.9c0,0,2.1-0.2,2.4-3V0H2.6z M6.8,4.5L5.7,3.9L4.6,4.5l0.2-1.2L4,2.5 l1.2-0.2l0.5-1.1l0.5,1.1l1.2,0.2L6.6,3.3L6.8,4.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCupIcon);
export default __webpack_public_path__ + "static/media/star-cup-icon.b28ef2f29f3eba7267c09010f1249065.svg";
export { ForwardRef as ReactComponent };